import { AuditClient } from '@frontend/audit/api';
import { AuditLog } from '@frontend/audit/types';
import { EntityType } from '@frontend/common';
import { ObjectList } from '@frontend/components/list';
import { useModals } from '@frontend/modal';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { AuditDataModal } from '../audit-data-modal/audit-data-modal.component';

interface AuditDetailItemProps {
    dispatch?: any;
    entityType?: EntityType;
    openModal: ReturnType<typeof useModals>['openModal'];
    closeModal: ReturnType<typeof useModals>['closeModal'];
}

export const AuditDetailItem = (props: AuditDetailItemProps, object: any): any => {
    const dataModalId = 'object-detail-audit-data-modal';

    const canShowAudit = props.dispatch && object && props.entityType;

    return {
        identifier: 'Audit',
        label: 'Audit',
        children: [
            canShowAudit ? (
                <ObjectList<AuditLog>
                    label={
                        <FormattedMessage
                            id='audit.logs'
                            defaultMessage='Audit Logs'
                        />
                    }
                    fetch={() => AuditClient.fetchAuditLogs(props.entityType!, object.id)}
                    columns={{ columns: ['type', 'user_id', 'log_timestamp'] }}
                    dispatch={props.dispatch}
                    type={EntityType.AUDIT}
                    onSelectElement={(log) =>
                        props.openModal(dataModalId, () => (
                            <AuditDataModal
                                audit={log}
                                onClose={() => props.closeModal(dataModalId)}
                            />
                        ))
                    }
                />
            ) : (
                <div className='flex flex-col items-center justify-center p-8 text-center'>
                    <p className='text-brand-muted text-lg'>
                        <FormattedMessage
                            id='audit.not-available'
                            defaultMessage='Audit logs are not available for this entity'
                        />
                    </p>
                </div>
            )
        ]
    };
};
